import { Input, Typography } from '@breetometer/components';
import { SearchIcon } from 'BreetAssets';
import { DEFAULT_INPUT_MAX_LENGTH, type IDropDownItem } from 'BreetHelpers';
import { type ChangeEvent, type MouseEvent, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';

import type { DropDownItemProps } from '../../Dropdown.helpers';
import DefaultItemOptions from '../item-options/Default';

export const DefaultDropdownItems = ({
	handleItemSelect,
	dropDownRef,
	inputValue,
	items,
	iconAs,
	hideValue,
	dropdownStyles,
	handleVisibility,
	hideSearch,
	CustomItemOption,
	searchItemPlaceholder,
}: DropDownItemProps) => {
	const [searchTerm, setSearchTerm] = useState('');

	const handleSearchTerm = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	}, []);

	const handleItemSelection = useCallback(
		(item: IDropDownItem) => {
			const handler = handleItemSelect?.(item);

			return (e: MouseEvent<HTMLButtonElement>) => {
				setSearchTerm('');
				handler?.(e);
				handleVisibility();
			};
		},
		[handleItemSelect, handleVisibility]
	);

	const handleSearchFilter = useCallback(
		(item: IDropDownItem) => {
			const serchItem = searchTerm.toLowerCase();

			return (
				item.name.toLowerCase().includes(serchItem) ||
				item.value.toLowerCase().includes(serchItem) ||
				item.code.toLowerCase().includes(serchItem)
			);
		},
		[searchTerm]
	);

	const filteredItems = items.filter(handleSearchFilter);

	return createPortal(
		<div
			className='dropdown_content_item bg-primary-500 border-tertiary-400'
			ref={dropDownRef}
			style={dropdownStyles}
			data-modal-ignore='true'
		>
			{!hideSearch && (
				<>
					{inputValue && (
						<div className='dropdown_content_item_label'>
							<Typography
								as='label'
								variant='sub_head'
							>
								{inputValue}
							</Typography>
						</div>
					)}
					<div className='dropdown_content_item_search'>
						<SearchIcon className='dropdown_content_item_search_icon' />
						<Input
							type='text'
							label=''
							id=''
							maxLength={DEFAULT_INPUT_MAX_LENGTH}
							value={searchTerm}
							onChange={handleSearchTerm}
							className='dropdown_content_item_search_input'
							widthType='full'
							placeholder={searchItemPlaceholder}
							data-modal-ignore='true'
						/>
					</div>
				</>
			)}

			<div className='dropdown_content_item_options'>
				<div className='dropdown_content_item_options_container scrollbar'>
					<DefaultItemOptions
						items={filteredItems}
						hideValue={hideValue}
						iconAs={iconAs}
						handleItemSelection={handleItemSelection}
						CustomItemOption={CustomItemOption}
					/>
					{filteredItems.length === 0 && (
						<div className='dropdown_content_item_options_item_no_country'>
							<Typography
								as='p'
								variant='sub_head'
							>
								No data found
							</Typography>
						</div>
					)}
				</div>
			</div>
		</div>,
		document.body
	);
};
